import { takeLatest, call, put, all, fork, select } from "redux-saga/effects";
import { updateApiCallStatus } from "./../../actions";
import SDK from "./../../sdk";
import { ManageDeviceActionTypes } from "app/ManageDevices/actions/index.model";
import {
  updateManageDevicesDetails,
  updateSignOutDeviceDetails,
} from "../actions";
import { RootState } from "app/reducers";
const state = (state: RootState) => state;
function* getManageDevicesDetails() {
  yield takeLatest(
    ManageDeviceActionTypes.GET_MANAGE_DEVICE_DETAILS,
    GetDevicesDetails
  );
}

export function* GetDevicesDetails(): any {
  try {
    yield put(
      updateApiCallStatus({
        status: "pending",
        module: ManageDeviceActionTypes.MANAGE_DEVICES_STATUS,
      })
    );
    const data: RootState = yield select(state);
    if (data.allLines?.userDetails) {
      const response = yield call(
        SDK.getManageDevicesDetails,
        data.allLines.userDetails.orig_tmobileid
      );
      yield put(updateManageDevicesDetails(response));
    }
    yield put(
      updateApiCallStatus({
        status: "final",
        module: ManageDeviceActionTypes.MANAGE_DEVICES_STATUS,
      })
    );
  } catch (error) {
    yield put(updateManageDevicesDetails({ data: [], status: 500 }));
    yield put(
      updateApiCallStatus({
        status: "error",
        module: ManageDeviceActionTypes.MANAGE_DEVICES_STATUS,
      })
    );
  }
}
function* signingOutDevice() {
  yield takeLatest(ManageDeviceActionTypes.SIGNINGOUT_DEVICE, SignOutDevice);
}

export function* SignOutDevice(payload: any): any {
  try {
    yield put(
      updateApiCallStatus({
        status: "pending",
        module: ManageDeviceActionTypes.MANAGE_DEVICES_STATUS,
      })
    );
    const response = yield call(SDK.signingOutDevice, payload.data);

    yield put(
      updateSignOutDeviceDetails({
        res: response,
        ownerId: payload.data.ownerId,
      })
    );
    // yield put(getDevicesDetails())
    yield put(
      updateApiCallStatus({
        status: "final",
        module: ManageDeviceActionTypes.MANAGE_DEVICES_STATUS,
      })
    );
  } catch (error) {
    yield put(
      updateSignOutDeviceDetails({ res: false, ownerId: payload.data.ownerId })
    );
    yield put(
      updateApiCallStatus({
        status: "error",
        module: ManageDeviceActionTypes.MANAGE_DEVICES_STATUS,
      })
    );
  }
}
export default function* manageDevicesSaga() {
  yield all([fork(getManageDevicesDetails), fork(signingOutDevice)]);
}
